


// import React, { useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
// import axios from 'axios';
// import Rightcontainer from '../Components/Rightcontainer';
// import socket from "../Components/socket";

// // Icons
// import { FaPlus, FaWallet, FaArrowUp, FaShieldAlt } from 'react-icons/fa';
// import { GiTrophy } from "react-icons/gi";

// const Mywallet = () => {
//     const history = useHistory();
//     let access_token = localStorage.getItem('token');
//     const [settinData, setSettingData] = useState(undefined);
//     const [user, setUser] = useState(null);

//     const fetchUserData = () => {
//         access_token = localStorage.getItem('token');
//         if (!access_token) {
//             history.push('/login');
//             window.location.reload();
//             return;
//         }
//         const headers = { Authorization: `Bearer ${access_token}` };
//         axios.get(`https://api.rrludo.in/me`, { headers })
//             .then(res => setUser(res.data))
//             .catch(e => {
//                 if (e.response && e.response.status === 401) {
//                     localStorage.removeItem('token');
//                     history.push('/login');
//                     window.location.reload();
//                 }
//             });
//     };

//     useEffect(() => {
//         fetchUserData();
//         socket.emit('websetting', '');
//     }, []);

//     useEffect(() => {
//         socket.on("websettingGet", (data) => {
//             localStorage.setItem("sitSetting", JSON.stringify(data));
//             setSettingData(data);
//         });
//         return () => socket.off("websettingGet");
//     }, [socket]);

//     const depositChips = user ? (user.Wallet_balance - user.withdrawAmount) : 0;
//     const winningChips = user?.withdrawAmount || 0;
//     const totalBalance = depositChips + winningChips;

//     // --- UNIQUE UI STYLES ---
//     const styles = {
//         container: {
//             background: '#0a0a0a',
//             minHeight: '100vh',
//             padding: '20px',
//             fontFamily: "'Poppins', sans-serif",
//             color: '#fff'
//         },
//         mainHub: {
//             background: 'linear-gradient(145deg, #1e1e1e, #111111)',
//             borderRadius: '30px',
//             padding: '30px',
//             textAlign: 'center',
//             position: 'relative',
//             overflow: 'hidden',
//             border: '1px solid rgba(255,255,255,0.05)',
//             marginBottom: '20px',
//             boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
//         },
//         accentGlow: {
//             position: 'absolute',
//             top: '-50px',
//             right: '-50px',
//             width: '150px',
//             height: '150px',
//             background: 'rgba(215, 25, 32, 0.15)',
//             filter: 'blur(50px)',
//             borderRadius: '50%'
//         },
//         totalLabel: {
//             fontSize: '12px',
//             textTransform: 'uppercase',
//             letterSpacing: '2px',
//             color: '#888',
//             marginBottom: '10px'
//         },
//         totalAmount: {
//             fontSize: '42px',
//             fontWeight: '800',
//             background: 'linear-gradient(to bottom, #fff, #888)',
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             margin: '0'
//         },
//         splitGrid: {
//             display: 'grid',
//             gridTemplateColumns: '1fr 1fr',
//             gap: '15px',
//             marginBottom: '25px'
//         },
//         miniCard: {
//             background: '#161616',
//             borderRadius: '24px',
//             padding: '20px 15px',
//             border: '1.5px dashed #cd1818',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             textAlign: 'center'
//         },
//         iconCircle: (color) => ({
//             width: '45px',
//             height: '45px',
//             borderRadius: '15px',
//             background: `rgba(${color}, 0.1)`,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             marginBottom: '12px',
//             color: `rgb(${color})`
//         }),
//         miniAmount: {
//             fontSize: '18px',
//             fontWeight: '700',
//             margin: '5px 0'
//         },
//         miniLabel: {
//             fontSize: '11px',
//             color: '#666',
//             fontWeight: '500'
//         },
//         actionSection: {
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '12px'
//         },
//         primaryBtn: (isRed) => ({
//             background: isRed ? 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)' : '#fff',
//             color: isRed ? '#fff' : '#000',
//             border: 'none',
//             borderRadius: '18px',
//             padding: '18px',
//             fontSize: '15px',
//             fontWeight: '700',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '10px',
//             cursor: 'pointer',
//             transition: 'transform 0.2s',
//             boxShadow: isRed ? '0 10px 20px rgba(186,0,0,0.3)' : '0 10px 20px rgba(255,255,255,0.1)'
//         }),
//         secondaryBtn: {
//             background: 'transparent',
//             border: '1px solid #333',
//             color: '#eee',
//             borderRadius: '18px',
//             padding: '16px',
//             fontSize: '14px',
//             fontWeight: '600',
//             cursor: 'pointer'
//         }
//     };

//     return (
//         <>
//             <div style={styles.container}>
//                 <div className='Orher_page_main_section' style={{maxWidth: '500px', margin: '0 auto'}}>
                    
//                     {/* Unified Balance Hub */}
//                     <div style={styles.mainHub}>
//                         <div style={styles.accentGlow}></div>
//                         <p style={styles.totalLabel}>Total Amount</p>
//                         <h1 style={styles.totalAmount}>₹{totalBalance.toFixed(2)}</h1>
//                         <div style={{marginTop: '15px', display: 'flex', justifyContent: 'center', gap: '10px'}}>
//                             <span style={{fontSize: '10px', color: '#444', background: '#000', padding: '4px 10px', borderRadius: '20px', border: '1px solid #222'}}>
//                                 <FaShieldAlt style={{marginRight: '5px'}}/> VERIFIED ACCOUNT
//                             </span>
//                         </div>
//                     </div>

//                     {/* Split Balance Grid */}
//                     <div style={styles.splitGrid}>
//                         <div style={styles.miniCard}>
//                             <div style={styles.iconCircle('255, 49, 49')}>
//                                 <FaWallet size={18} />
//                             </div>
//                             <p style={styles.miniLabel}>Deposited</p>
//                             <h3 style={styles.miniAmount}>₹{depositChips.toFixed(2)}</h3>
//                         </div>
//                         <div style={styles.miniCard}>
//                             <div style={styles.iconCircle('255, 215, 0')}>
//                                 <GiTrophy size={22} />
//                             </div>
//                             <p style={styles.miniLabel}>Winnings</p>
//                             <h3 style={styles.miniAmount}>₹{winningChips.toFixed(2)}</h3>
//                         </div>
//                     </div>

//                     {/* Quick Actions Blade */}
//                     <div style={styles.actionSection}>
//                         <Link to={settinData?.isDeposit ? "/addcase" : "#"} style={{textDecoration: 'none'}}>
//                             <button 
//                                 style={{...styles.primaryBtn(true), width: '100%'}}
//                                 disabled={!settinData?.isDeposit}
//                             >
//                                 <FaPlus /> ADD CASH
//                             </button>
//                         </Link>

//                         <Link to={settinData?.isWithdrawal ? "/Withdrawopt" : "#"} style={{textDecoration: 'none'}}>
//                             <button 
//                                 style={{...styles.primaryBtn(false), width: '100%'}}
//                                 disabled={!settinData?.isWithdrawal}
//                             >
//                                 <FaArrowUp /> WITHDRAW WINNINGS
//                             </button>
//                         </Link>

//                         <button style={styles.secondaryBtn} onClick={() => history.push('/transaction-history')}>
//                             VIEW RECENT TRANSACTIONS
//                         </button>
//                     </div>

//                     <div style={{textAlign: 'center', marginTop: '30px', opacity: '0.4', fontSize: '10px', letterSpacing: '1px'}}>
//                         ENCRYPTED GATEWAY ID: {user?._id?.slice(-8).toUpperCase()}
//                     </div>
//                 </div>
//             </div>

//             <div className='rightContainer'>
//                 <Rightcontainer />
//             </div>
//         </>
//     );
// }

// export default Mywallet;


import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import Rightcontainer from '../Components/Rightcontainer';
import socket from "../Components/socket";

// Icons
import { FaPlus, FaArrowDown, FaHistory, FaShieldAlt, FaChevronRight, FaGem } from 'react-icons/fa';
import { IoMdWallet } from "react-icons/io";

const Mywallet = () => {
    const history = useHistory();
    let access_token = localStorage.getItem('token');
    const [settinData, setSettingData] = useState(undefined);
    const [user, setUser] = useState(null);

    const fetchUserData = () => {
        access_token = localStorage.getItem('token');
        if (!access_token) {
            history.push('/login');
            window.location.reload();
            return;
        }
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.get(`https://api.rrludo.in/me`, { headers })
            .then(res => setUser(res.data))
            .catch(e => {
                if (e.response && e.response.status === 401) {
                    localStorage.removeItem('token');
                    history.push('/login');
                    window.location.reload();
                }
            });
    };

    useEffect(() => {
        fetchUserData();
        socket.emit('websetting', '');
    }, []);

    useEffect(() => {
        socket.on("websettingGet", (data) => {
            localStorage.setItem("sitSetting", JSON.stringify(data));
            setSettingData(data);
        });
        return () => socket.off("websettingGet");
    }, [socket]);

    const depositChips = user ? (user.Wallet_balance - user.withdrawAmount) : 0;
    const winningChips = user?.withdrawAmount || 0;
    const totalBalance = depositChips + winningChips;

    // --- NEW EXPERIMENTAL LAYOUT STYLES ---
    const styles = {
        wrapper: {
            background: '#FFFDE7', // Creamy Light Yellow
            minHeight: '100vh',
            fontFamily: "'Poppins', sans-serif",
           
        },
        topSection: {
            background: '#000',
            padding: '40px 25px 80px 25px',
            borderBottomLeftRadius: '40px',
            borderBottomRightRadius: '40px',
            color: '#fff',
        },
        headerRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px'
        },
        balanceGroup: {
            textAlign: 'left'
        },
        floatingCard: {
            background: '#fff',
            margin: '-50px 20px 20px 20px',
            borderRadius: '25px',
            padding: '25px',
            boxShadow: '0 15px 35px rgba(255, 152, 0, 0.1)',
            border: '1px solid #FFF9C4'
        },
        statRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 0',
            borderBottom: '1px solid #f9f9f9'
        },
        circleIcon: (bg) => ({
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            background: bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#000'
        }),
        actionGrid: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '15px',
            padding: '10px 20px'
        },
        bigBtn: (isBlack) => ({
            background: isBlack ? '#000' : '#FF9800',
            color: isBlack ? '#FFEB3B' : '#000',
            border: 'none',
            borderRadius: '20px',
            height: '110px',
            display: 'flex',
            padding: '20px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            fontWeight: '700',
            fontSize: '14px',
            cursor: 'pointer',
            boxShadow: isBlack ? 'none' : '0 10px 20px rgba(255, 152, 0, 0.2)',
        }),
        listMenu: {
            margin: '20px',
            background: '#fff',
            borderRadius: '20px',
            overflow: 'hidden'
        },
        menuItem: {
            display: 'flex',
            alignItems: 'center',
            padding: '18px 20px',
            gap: '15px',
            borderBottom: '1px solid #f5f5f5',
            cursor: 'pointer',
            textDecoration: 'none',
            color: '#000'
        }
    };

    return (
        <>
            <div style={styles.wrapper} className='pb-5'>
                <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                    
                    {/* Top Aesthetic Header */}
                    <div style={styles.topSection}>
                        <div style={styles.headerRow}>
                            <div style={styles.balanceGroup}>
                                <p style={{ color: '#FF9800', fontSize: '12px', fontWeight: '700', margin: 0, letterSpacing: '1px' }}>TOTAL AMOUNT</p>
                                <h1 style={{ fontSize: '40px', margin: '5px 0', fontWeight: '800' }}>₹{totalBalance.toFixed(2)}</h1>
                            </div>
                            <div style={styles.circleIcon('#FF9800')}>
                                <IoMdWallet size={24} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '11px', color: '#666' }}>
                            <FaShieldAlt color="#FF9800" style={{ marginRight: '5px' }} /> 
                            256-BIT SSL SECURED PAYMENT GATEWAY
                        </div>
                    </div>

                    {/* Breakdown Card */}
                    <div style={styles.floatingCard}>
                        <div style={styles.statRow}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <div style={styles.circleIcon('#FFF9C4')}><FaGem size={18} /></div>
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#888', fontWeight: '600' }}>Deposit Chips</p>
                                    <p style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>₹{depositChips.toFixed(2)}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ ...styles.statRow, borderBottom: 'none' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <div style={styles.circleIcon('#FFE082')}><FaArrowDown size={18} /></div>
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#888', fontWeight: '600' }}>Winning Chips</p>
                                    <p style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>₹{winningChips.toFixed(2)}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Grid - Visual Change */}
                    <div style={styles.actionGrid}>
                        <Link to={settinData?.isDeposit ? "/addcase" : "#"} style={{ textDecoration: 'none' }}>
                            <button style={styles.bigBtn(false)} disabled={!settinData?.isDeposit}>
                                <div style={{ background: '#000', padding: '10px', borderRadius: '12px' }}>
                                    <FaPlus color="#FF9800" />
                                </div>
                                ADD CASH
                            </button>
                        </Link>
                        <Link to={settinData?.isWithdrawal ? "/Withdrawopt" : "#"} style={{ textDecoration: 'none' }}>
                            <button style={styles.bigBtn(true)} disabled={!settinData?.isWithdrawal}>
                                <div style={{ background: '#FF9800', padding: '10px', borderRadius: '12px' }}>
                                    <IoMdWallet color="#000" />
                                </div>
                                WITHDRAW
                            </button>
                        </Link>
                    </div>

                    {/* List Style Menu */}
                    <div style={styles.listMenu}>
                        <div style={styles.menuItem} onClick={() => history.push('/transaction-history')}>
                            <FaHistory color="#FF9800" />
                            <span style={{ flex: 1, fontWeight: '700', fontSize: '14px' }}>Transaction History</span>
                            <FaChevronRight size={12} color="#ccc" />
                        </div>
                    </div>

                    {/* <p style={{ textAlign: 'center', color: '#bbb', fontSize: '10px', fontWeight: '700' }}>
                        ACCOUNT ID: {user?._id?.toUpperCase()}
                    </p> */}
                </div>
            </div>

            <div className='rightContainer'>
                <Rightcontainer />
            </div>
        </>
    );
}

export default Mywallet;
